import { useState, useEffect, useCallback } from 'react';
import { authService } from '../services/authService';
import { leaveService } from '../services/leaveService';

export const useEmployeeNotifications = () => {
  const [rejectedLeavesCount, setRejectedLeavesCount] = useState<number>(0);
  const [rejectedTimesheetsCount, setRejectedTimesheetsCount] = useState<number>(0);
  const [draftTimesheetId, setDraftTimesheetId] = useState<number | null>(null);

  const fetchNotifications = useCallback(async () => {
    try {
      const token = authService.getAccessToken();
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      };

      // 1. Récupération des feuilles de temps
      const tsResponse = await fetch('/api/timesheets/', { headers });
      if (tsResponse.ok) {
        const data = await tsResponse.json();
        const list: any[] = data.results || data;
        
        const draft = list.find(t => {
          const status = String(t.status || '').toLowerCase();
          return status === 'draft' || status === 'brouillon';
        });

        // Uniquement les feuilles de temps refusées
        const rejectedTs = list.filter(t => {
          const status = String(t.status || '').toLowerCase();
          return ['rejected', 'refuse', 'refusée'].includes(status);
        });
        
        setRejectedTimesheetsCount(rejectedTs.length);
        setDraftTimesheetId(draft ? draft.id : null);
      }

      // 2. Récupération des congés (UNIQUEMENT les refusés)
      const leavesData = await leaveService.getLeaveRequests();
      const leavesList: any[] = leavesData.results || leavesData;

      const rejectedLeaves = leavesList.filter(l => {
        const status = String(l.status || '').toLowerCase();
        return [
          'rejected', 'refuse', 'refusée'
        ].includes(status);
      });
      
      setRejectedLeavesCount(rejectedLeaves.length);
    } catch (err) {
      console.error("Erreur chargement notifications employé :", err);
    }
  }, []);

  useEffect(() => {
    fetchNotifications();

    // Écoute des événements globaux pour rafraîchir en temps réel
    window.addEventListener('timesheetStatusUpdated', fetchNotifications);
    window.addEventListener('leaveStatusUpdated', fetchNotifications);

    return () => {
      window.removeEventListener('timesheetStatusUpdated', fetchNotifications);
      window.removeEventListener('leaveStatusUpdated', fetchNotifications);
    };
  }, [fetchNotifications]);

  return {
    rejectedLeavesCount,
    rejectedTimesheetsCount,
    draftTimesheetId,
  };
};